

import logo_pp_sm from '../../../assets/images/logo-portplay-stacked.svg';
import logo_pp_lg from '../../../assets/images/logo-portplay-horizontal.svg';
import icon_discord from '../../../assets/images/icon-discord.png';
import icon_mail from '../../../assets/images/icon-mail.png';
import bg_skyline from '../../../assets/images/background-skyline.png';

import styled from 'styled-components'
import { EmailUsForm } from './EmailUsForm';


const Wrapper  = styled.div<{$img: string}>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
  flex-direction: column;
    

  .pp-logo-sm {
    display: block;
  }
  .pp-logo-lg {
    display: none;
  }
  .hr-divider {
    display: none;
  }

  @media (min-width: 800px) {
    .pp-logo-sm {
      display: none;
    }
    .pp-logo-lg {
      display: block;
      max-width: 1200px;
    }
    .hr-divider {
      display: block;
    }
  }
  .text-block {
    display: block;
  }


  .contact-us {
    background-image: url('${props => props.$img}');
    background-position: center bottom;
    background-repeat: no-repeat;
    background-position: center; background-size: cover;


    padding-top: 3rem;
    padding-bottom: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;
    flex-direction: column;
  }

  .contact-us-item {
    margin-right: 2rem;
    max-height: 700px;
  }
  .contact-us-item-maxed {
    margin-right: 2rem;
    min-width: 97%;
    max-height: 700px;
  }

  .contact-us-grid {
    display: grid;
    grid-template-columns: 1fr 3fr;
    grid-template-rows: 1fr 1fr;
    column-gap: 0.5rem;
  }
  .contact-us-spacer {
    min-height: 100px;
  }

  @media (min-width: 992px) {
    .contact-us {      
      max-height: 100%;

    }
    .contact-us-item-1 {
      max-height: 100%;
    }
  }

`

/**
 * ***Uncaught ReferenceError***
 * 
 * Still trying to understand this but...
 * If we include <EmailUsForm/> both here (see bottom of component) and in Home.tsx
 * 
 * we get the dreaded: "Uncaught ReferenceError: Cannot access EmailUsForm before initialization"
 * 
 * By commenting that component out of Home.tsx - the issue goes away !!!
 * WTF
 */
export const Splash = () => {


  return (
    <Wrapper $img={bg_skyline}>

      {/* <div className='pp-logo'> */}
        <img src={logo_pp_sm} alt='port play' className='pp-logo-sm'/>
        <img src={logo_pp_lg} alt='port play' className='pp-logo-lg' />
      {/* </div> */}

      <div>&nbsp;</div>
      <div className='lr-padded-container spaced-headlines'>
        <h1 style={{marginBottom: '25px'}}>2026</h1>
        <h2 style={{marginBottom: '25px'}}>tabletop game & art festival</h2>
        <hr style={{maxWidth: '200px', marginInline: 'auto'}}/>
        <h2>St Kilda Town Hall & St Kilda Library</h2>
        <h2>Saturday and Sunday 18-19th April 2026</h2>
      </div>

      <div className='contact-us lr-padded-container'>
        <div className='contact-us-item'>
          <p>Celebrating everything creative about tabletop gaming in Victoria, Port Play invites you to experience the games, art and adventures that local creators are bringing into our world.</p>
          <p>Port Play is a 2 day journey of discovery brought to you by volunteers in partnership with the City of Port Philip for the love and celebration of what tabletop gaming brings into our lives and the diverse and supportive communities it creates.</p>
        </div>

        <div className='contact-us-item-maxed'>
          <p>To be the first to know when tickets go on sale and updates on events running in 2026:</p>
        </div>

        <div className='contact-us-grid'>
          <div><a href='mailto:arcanacon.orgs@gmail.com'><img src={icon_mail} alt='email arc' style={{width:'60px', height: '60px'}}/></a></div>
          <div><p>Email: <a href='mailto:arcanacon.orgs@gmail.com'>arcanacon.orgs@gmail.com</a></p></div>
          <div><a href="https://discord.gg/M9Wq7wzdC4"><img src={icon_discord} alt='discord' style={{width:'60px', height: '60px'}}/></a></div>
          <div><p><a href="https://discord.gg/M9Wq7wzdC4">ARC discord</a></p></div>
        </div>
        <div className='contact-us-item'><p>Or use the contact form below:</p></div>
        <div className='contact-us-spacer'>&nbsp;</div>
        <div className='contact-us-item'><EmailUsForm/></div>
        
      </div>


    </Wrapper>
  )
}
